import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import InfoTooltip from './InfoTooltip.js';
import './knowledgeOverview.css';

// The red "failed" marker on a knowledge row. The backend stores a
// customer-facing `failure_reason` on the row (e.g. the 10 MB size cap, "could
// not extract content"); hovering the X shows it in the shared InfoTooltip
// (error variant) instead of a bare browser title.
export default function FailedStatusIcon({ reason, style }) {
  const { t } = useTranslation();
  const text = (reason || '').trim() || t('knowledge_failed_generic', 'Processing failed. Try again or replace the source.');
  return (
    <InfoTooltip text={text} variant="error">
      <FontAwesomeIcon icon={faCircleXmark} className="knowledge-bad-status-icon" style={style} />
    </InfoTooltip>
  );
}

// The reason as its own cell of the row (a flex sibling between the name and
// the date on the card lists; inline in the website-links tree), with a warning
// triangle in front. The full sentence is in the tooltip on hover. Renders
// nothing unless the row is failed with a reason.
export function FailureReason({ status, reason, inline = false }) {
  const text = (reason || '').trim();
  if (status !== 'failed' || !text) return null;
  const body = (
    <InfoTooltip text={text} variant="error">
      <span className="knowledge-failure-reason">
        <FontAwesomeIcon icon={faTriangleExclamation} className="knowledge-failure-icon" />
        <span className="knowledge-failure-text">{text}</span>
      </span>
    </InfoTooltip>
  );
  return inline ? body : <div className="knowledge-failure-slot">{body}</div>;
}
